const $clearFiltersButton = $('[data-clear-filters]');
const $openMobileFilters = $('[data-open-mobile-filters]');
const $closeMobileFilters = $('[data-close-mobile-filters]');
const $mobileFilterPanel = $('[data-mobile-filter-panel]');

function initSorting() {
  Shopify.queryParams = {};
  if(location.search.length) {
      for(var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
              Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
      }
  }

  // Add existing sort parameters to current URL
  $('[data-sort-input]').on('change', function(e) {
    var value = e.currentTarget.value;
    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
  });
}

document.addEventListener('DOMContentLoaded',() => {
  initSorting();
  const mixer = mixitup('[data-product-grid]', {
    multifilter: {
      enable: true
    },
    animation: {
      enable: false
    },
    callbacks: {
      onMixEnd: function(state) {
        if (state.activeFilter.selector === 'all') {
          $clearFiltersButton.fadeOut();
        } else {
          $clearFiltersButton.fadeIn();
        }
      }
    }
  });

//$clearFiltersButton.on('click',() => {
  //mixer.filter('.mix');
    //$('[data-filter-group]').find('input:checked').prop('checked',false).change();
  //});
 
$clearFiltersButton.on('click', () => {
  const $inputs = $('[data-filter-group]').find('input[type="checkbox"]');
  $inputs.prop('checked', false).trigger('change');
  mixer.filter('all');
});

  $openMobileFilters.on('click',() => {
    $mobileFilterPanel.addClass('active');
  });

  $closeMobileFilters.on('click',() => {
    $mobileFilterPanel.removeClass('active');
  });

});